export type LegalEntity = 'LUX' | 'MCO'

export const toLegalEntity = (str: string) : LegalEntity => {
  if(str == 'LUX' || str == 'MCO') return str
  throw new Error("Unknown legal entity : " + str)
}